@if (loaded()) {
    @if (errored()) {
        <div class="flex flex-col items-center text-center pb-9 gap-y-4">
            <mat-icon
                class="!w-12 !h-11"
                svgIcon="app:empty_box"
            ></mat-icon>
            <span class="text-dat-grey-500 font-caption-strong leading-4">
                {{ errorMessage() }}
            </span>
        </div>
    } @else {
        <div
            class="border border-solid border-grey-100 px-4 rounded w-full h-full max-h-132 overflow-y-scroll"
            data-uitype="table-contributions"
        >
            <cdk-table
                class="grid label"
                [ngClass]="colsClasses().gridCols"
                [dataSource]="contributions()"
            >
                <ng-container cdkColumnDef="pickup">
                    <cdk-header-cell
                        class="flex items-center justify-end px-4"
                        *cdkHeaderCellDef
                    >
                        <button class="flex items-center gap-x-1" (click)="setSort('pickup')">
                            Pickup
                            @if (sort().column === 'pickup') {
                                @if (sort().asc) {
                                    <span class="material-symbols-outlined text-base leading-4">
                                        arrow_upward
                                    </span>
                                } @else {
                                    <span class="material-symbols-outlined text-base leading-4">
                                        arrow_downward
                                    </span>
                                }
                            }
                        </button>
                    </cdk-header-cell>
                    <cdk-cell
                        class="flex items-center justify-end px-4"
                        *cdkCellDef="let contribution"
                    >
                        {{ contribution.pickupDate | date: 'M/dd/yy' }}
                    </cdk-cell>
                </ng-container>
        
                <ng-container cdkColumnDef="brokerPaidToCarrier">
                    <cdk-header-cell
                        class="flex items-center justify-end px-4"
                        *cdkHeaderCellDef
                    >
                        <button class="flex items-center gap-x-1" (click)="setSort('brokerPaidToCarrier')">
                            Paid to Carrier
                            @if (sort().column === 'brokerPaidToCarrier') {
                                @if (sort().asc) {
                                    <span class="material-symbols-outlined text-base leading-4">
                                        arrow_upward
                                    </span>
                                } @else {
                                    <span class="material-symbols-outlined text-base leading-4">
                                        arrow_downward
                                    </span>
                                }
                            }
                        </button>
                    </cdk-header-cell>
                    <cdk-cell
                        class="label-strong flex items-center justify-end px-4" 
                        *cdkCellDef="let contribution"
                    >
                        {{ contribution.totalPaidByBroker | currency }}
                    </cdk-cell>
                </ng-container>

                <ng-container cdkColumnDef="totalPaidByShipper">
                    <cdk-header-cell class="flex items-center justify-end px-4" *cdkHeaderCellDef>
                        <button class="flex items-center gap-x-1" (click)="setSort('totalPaidByShipper')">
                            Received @if (sort().column ===
                            'totalPaidByShipper') { @if (sort().asc) {
                            <span class="material-symbols-outlined text-base leading-4">
                                arrow_upward
                            </span>
                            } @else {
                            <span class="material-symbols-outlined text-base leading-4">
                                arrow_downward
                            </span>
                            } }
                        </button>
                    </cdk-header-cell>
                    <cdk-cell class="label-strong flex items-center justify-end px-4" *cdkCellDef="let contribution">
                        {{ contribution.totalPaidByShipper | currency }}
                    </cdk-cell>
                </ng-container>
        
                <ng-container cdkColumnDef="brokerReceived">
                    <cdk-header-cell
                        class="flex items-center justify-end px-4"
                        *cdkHeaderCellDef
                    >
                        <button class="flex items-center gap-x-1" (click)="setSort('brokerReceived')">
                            Received
                            @if (sort().column === 'brokerReceived') {
                                @if (sort().asc) {
                                    <span class="material-symbols-outlined text-base leading-4">
                                        arrow_upward
                                    </span>
                                } @else {
                                    <span class="material-symbols-outlined text-base leading-4">
                                        arrow_downward
                                    </span>
                                }
                            }
                        </button>
                    </cdk-header-cell>
                    <cdk-cell
                        class="label-strong flex items-center justify-end px-4" 
                        *cdkCellDef="let contribution"
                    >
                        {{ contribution.totalPaidByShipper | currency }}
                    </cdk-cell>
                </ng-container>
        
                <ng-container cdkColumnDef="carrierReceivedFromBroker">
                    <cdk-header-cell
                        class="flex items-center justify-end px-4"
                        *cdkHeaderCellDef
                    >
                        <button class="flex items-center gap-x-1" (click)="setSort('carrierReceivedFromBroker')">
                            Received
                            @if (sort().column === 'carrierReceivedFromBroker') {
                                @if (sort().asc) {
                                    <span class="material-symbols-outlined text-base leading-4">
                                        arrow_upward
                                    </span>
                                } @else {
                                    <span class="material-symbols-outlined text-base leading-4">
                                        arrow_downward
                                    </span>
                                }
                            }
                        </button>
                    </cdk-header-cell>
                    <cdk-cell
                        class="label-strong flex items-center justify-end px-4" 
                        *cdkCellDef="let contribution"
                    >
                        {{ contribution.totalPaidByBroker | currency }}
                    </cdk-cell>
                </ng-container>
        
                <ng-container cdkColumnDef="carrierReceivedFromShipper">
                    <cdk-header-cell
                        class="flex items-center justify-end px-4"
                        *cdkHeaderCellDef
                    >
                        <button class="flex items-center gap-x-1" (click)="setSort('carrierReceivedFromShipper')">
                            Received
                            @if (sort().column === 'carrierReceivedFromShipper') {
                                @if (sort().asc) {
                                    <span class="material-symbols-outlined text-base leading-4">
                                        arrow_upward
                                    </span>
                                } @else {
                                    <span class="material-symbols-outlined text-base leading-4">
                                        arrow_downward
                                    </span>
                                }
                            }
                        </button>
                    </cdk-header-cell>
                    <cdk-cell
                        class="label-strong flex items-center justify-end px-4" 
                        *cdkCellDef="let contribution"
                    >
                        {{ contribution.totalPaidByShipper | currency }}
                    </cdk-cell>
                </ng-container>
        
                <ng-container cdkColumnDef="shipperPaidToBroker">
                    <cdk-header-cell *cdkHeaderCellDef>
                        <button class="flex items-center gap-x-1" (click)="setSort('shipperPaidToBroker')">
                            Paid to Broker
                            @if (sort().column === 'shipperPaidToBroker') {
                                @if (sort().asc) {
                                    <span class="material-symbols-outlined text-base leading-4">
                                        arrow_upward
                                    </span>
                                } @else {
                                    <span class="material-symbols-outlined text-base leading-4">
                                        arrow_downward
                                    </span>
                                }
                            }
                        </button>
                    </cdk-header-cell>
                    <cdk-cell *cdkCellDef="let contribution">
                        {{ contribution.totalPaidByShipper | currency }}
                    </cdk-cell>
                </ng-container>
        
                <ng-container cdkColumnDef="shipperPaidToCarrier">
                    <cdk-header-cell *cdkHeaderCellDef>
                        <button class="flex items-center gap-x-1" (click)="setSort('shipperPaidToCarrier')">
                            Paid to Carrier
                            @if (sort().column === 'shipperPaidToCarrier') {
                                @if (sort().asc) {
                                    <span class="material-symbols-outlined text-base leading-4">
                                        arrow_upward
                                    </span>
                                } @else {
                                    <span class="material-symbols-outlined text-base leading-4">
                                        arrow_downward
                                    </span>
                                }
                            }
                        </button>
                    </cdk-header-cell>
                    <cdk-cell *cdkCellDef="let contribution">
                        {{ contribution.totalPaidByShipper | currency }}
                    </cdk-cell>
                </ng-container>
        
                <ng-container cdkColumnDef="originDestination">
                    <cdk-header-cell
                        class="flex items-center justify-start px-4"
                        *cdkHeaderCellDef
                    >
                        <button class="flex items-center gap-x-1" (click)="setSort('originDestination')">
                            O/D
                            @if (sort().column === 'originDestination') {
                                @if (sort().asc) {
                                    <span class="material-symbols-outlined text-base leading-4">
                                        arrow_upward
                                    </span>
                                } @else {
                                    <span class="material-symbols-outlined text-base leading-4">
                                        arrow_downward
                                    </span>
                                }
                            }
                        </button>
                    </cdk-header-cell>
                    <cdk-cell
                        class="flex items-center justify-start px-4"
                        *cdkCellDef="let contribution"
                    >
                        <div class="flex gap-x-1">
                            <div class="flex flex-col justify-center">
                                <svg width="5" height="22" viewBox="0 0 5 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 4.07143C3.09173 4.07143 3.57143 3.59173 3.57143 3C3.57143 2.40827 3.09173 1.92857 2.5 1.92857C1.90827 1.92857 1.42857 2.40827 1.42857 3C1.42857 3.59173 1.90827 4.07143 2.5 4.07143ZM2.5 5.5C3.88071 5.5 5 4.38071 5 3C5 1.61929 3.88071 0.5 2.5 0.5C1.11929 0.5 0 1.61929 0 3C0 4.38071 1.11929 5.5 2.5 5.5Z" fill="#192129"/>
                                    <path d="M3 13.5V12.4887H2L2 13.5H3Z" fill="#636D79"/>
                                    <path d="M3 11.4776V10.4665H2L2 11.4776H3Z" fill="#636D79"/>
                                    <path d="M3 9.45544V8.44437H2L2 9.45544H3Z" fill="#636D79"/>
                                    <path d="M3 7.4333V6.5H2L2 7.4333H3Z" fill="#636D79"/>
                                    <g clip-path="url(#clip0_4557_18980)">
                                    <path d="M4.5 13.8817L4.02833 13.5L2.5 14.7367L0.971667 13.5L0.5 13.8817L2.5 15.5L4.5 13.8817Z" fill="#636D79"/>
                                    </g>
                                    <circle cx="2.5" cy="19" r="2" fill="#192129" stroke="#192129"/>
                                    <defs>
                                    <clipPath id="clip0_4557_18980">
                                    <rect width="2" height="4" fill="white" transform="matrix(0 1 -1 0 4.5 13.5)"/>
                                    </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <div class="flex flex-col">
                                <div class="flex justify-start">
                                    {{ contribution.originCity }},
                                    {{ contribution.originState }}
                                    {{ contribution.originZipCode }}
                                </div>
                                <div class="flex justify-start">
                                    {{ contribution.destinationCity }},
                                    {{ contribution.destinationState }}
                                    {{ contribution.destinationZipCode }}
                                </div>
                            </div>
                        </div>
                    </cdk-cell>
                </ng-container>
        
                <ng-container cdkColumnDef="broker">
                    <cdk-header-cell
                        class="flex items-center justify-start px-4"
                        *cdkHeaderCellDef
                    >
                        <button class="flex items-center gap-x-1" (click)="setSort('broker')">
                            Broker
                            @if (sort().column === 'broker') {
                                @if (sort().asc) {
                                    <span class="material-symbols-outlined text-base leading-4">
                                        arrow_upward
                                    </span>
                                } @else {
                                    <span class="material-symbols-outlined text-base leading-4">
                                        arrow_downward
                                    </span>
                                }
                            }
                        </button>
                    </cdk-header-cell>
                    <cdk-cell
                        class="flex items-center justify-start px-4"
                        *cdkCellDef="let contribution"
                    >
                        {{ contribution.brokerName }}
                    </cdk-cell>
                </ng-container>
        
                <ng-container cdkColumnDef="shipper">
                    <cdk-header-cell
                        class="flex items-center justify-start px-4"
                        *cdkHeaderCellDef
                    >
                        <button class="flex items-center gap-x-1" (click)="setSort('shipper')">
                            Shipper
                            @if (sort().column === 'shipper') {
                                @if (sort().asc) {
                                    <span class="material-symbols-outlined text-base leading-4">
                                        arrow_upward
                                    </span>
                                } @else {
                                    <span class="material-symbols-outlined text-base leading-4">
                                        arrow_downward
                                    </span>
                                }
                            }
                        </button>
                    </cdk-header-cell>
                    <cdk-cell
                        class="flex items-center justify-start px-4"
                        *cdkCellDef="let contribution"
                    >
                        {{ contribution.shipperName }}
                    </cdk-cell>
                </ng-container>
        
                <ng-container cdkColumnDef="carrier">
                    <cdk-header-cell
                        class="flex items-center justify-start px-4"
                        *cdkHeaderCellDef
                    >
                        <button class="flex items-center gap-x-1" (click)="setSort('carrier')">
                            Carrier
                            @if (sort().column === 'carrier') {
                                @if (sort().asc) {
                                    <span class="material-symbols-outlined text-base leading-4">
                                        arrow_upward
                                    </span>
                                } @else {
                                    <span class="material-symbols-outlined text-base leading-4">
                                        arrow_downward
                                    </span>
                                }
                            }
                        </button>
                    </cdk-header-cell>
                    <cdk-cell
                        class="flex items-center justify-start px-4"
                        *cdkCellDef="let contribution"
                    >
                        {{ contribution.carrierName }}
                    </cdk-cell>
                </ng-container>
        
                <cdk-header-row
                    class="grid grid-cols-subgrid h-12 box-content bg-white border-b border-solid border-b-dat-grey-200 text-dat-grey-500"
                    [ngClass]="colsClasses().colSpan"
                    *cdkHeaderRowDef="displayedColumns(); sticky: true"
                ></cdk-header-row>
                <cdk-row
                    class="grid grid-cols-subgrid h-12 box-content border-b border-solid border-b-dat-grey-100 last:border-none text-dat-grey-900"
                    [ngClass]="colsClasses().colSpan"
                    *cdkRowDef="let row; columns: displayedColumns()"
                ></cdk-row>
            </cdk-table>
        </div>
    }
} @else {
    <div
        class="w-full h-132 animate-pulse bg-dat-grey-200"
    ></div>
}
